import { useCallback } from 'react'

import { useMetadata } from '@scoir/tracking'

import { FIELDS } from 'common/metadata-constants'
import { useMetadataToTrackedEvent } from 'common/metadata-custom-hooks'
import trackEvents from 'common/track-events'

import { ITrackEvent } from './types'

export const useClickTracking = (eventType: string, to?: string) => {
  const getFn = useMetadataToTrackedEvent(eventType)
  const [get] = useMetadata()
  const cb = useCallback(() => {
    const te: ITrackEvent = getFn()
    const data = get()
    trackEvents({
      ...te,
      EventData: {
        ...te.EventData,
        selectLinkUrl: to,
        [FIELDS.TOP_OPTIONS]: data[FIELDS.TOP_OPTIONS],
      },
    })
  }, [getFn, get, to])
  return cb
}
